import { IconBrandGoogle } from "@tabler/icons-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useLoginDialogStore } from "@/stores/loginDialog";
import { useUserStore } from "@/stores/user";

function LoginModal() {
  const open = useLoginDialogStore((state) => state.open);
  const setOpen = useLoginDialogStore((state) => state.setOpen);
  const info = useUserStore((state) => state.info);
  const googleLogin = useUserStore((state) => state.googleLogin);
  const logout = useUserStore((state) => state.logout);
  const login = () => { setOpen(false); void googleLogin(); };
  const signOut = () => { setOpen(false); logout(); };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="w-[calc(100%-2rem)] max-w-sm border-primary p-6"
        showCloseButton={false}
        onOpenAutoFocus={(event) => event.preventDefault()}
        onCloseAutoFocus={(event) => event.preventDefault()}
      >
        <DialogHeader className="text-center sm:text-center">
          <DialogTitle className={info ? "mt-4 leading-6" : undefined}>{info ? <>{info.name}<br />{info.email}</> : "Login to your Account?"}</DialogTitle>
          <DialogDescription className="sr-only">{info ? "Review the active Batu Ice account or log out." : "Login with your Google account to access Batu Ice account features."}</DialogDescription>
        </DialogHeader>
        {info ? <DialogFooter className="mt-2 sm:justify-stretch"><Button className="w-full" variant="secondary" onClick={signOut}>Logout</Button></DialogFooter> : <>
          <Button className="mt-3 w-full border-primary hover:bg-primary" variant="outline" onClick={login}><IconBrandGoogle className="size-5 stroke-[1.5]" aria-hidden="true" /> Sign in with Google</Button>
          <p className="mb-0 mt-2 text-center text-sm leading-5 text-muted-foreground">Gunakan browser chrome<br />atau nonaktifkan pop-up bloker.</p>
        </>}
      </DialogContent>
    </Dialog>
  );
}

export { LoginModal };
